import { Gutter } from '@gaiads/telia-react-component-library';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import OrderStepper from './OrderStepper/OrderStepper';
import SelectProduct from './SelectProduct/SelectProduct';
import CheckoutDetails from './CheckoutDetails/CheckoutDetails';
import DeliveryOptions from './DeliveryOptions/DeliveryOptions';
import OrderCompleted from './OrderCompleted/OrderCompleted';
import { getStorageItems, ORDER_FLOW_CONSTANTS, typeGuards, UserResponseWithUserGroup } from '../../utils';
import Bundle from './Bundle/Bundle';
import OrderFlowLayout from '../App/Layouts/OrderFlowLayout';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectOrganization,
  selectSalesChannel,
  selectSelectedUser,
  setOrderOrganization,
  setOrderSalesChannel,
  setOrderUser,
} from '../../store/order';
import { OrganizationResponse } from '@cdaas/api-clients/dist/asset-admin-openapi';
import { AppDispatch } from '../../store';
import { Loader } from '../App/Loader';
import { SalesChannel } from '@cdaas/api-clients/dist/product-service-openapi';

export const MOBILE_BREAKPOINT = 1080;

export default function Order() {
  const { path } = useRouteMatch();
  const dispatch: AppDispatch = useDispatch();

  const organization: OrganizationResponse | null = useSelector(selectOrganization);
  const salesChannel: SalesChannel | null = useSelector(selectSalesChannel);
  const user: UserResponseWithUserGroup | null = useSelector(selectSelectedUser);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const [organizationInSessionStorage, salesChannelInSessionStorage, userInSessionStorage, orderForOrganizationSessionStorage] = getStorageItems(
      ['tSelectedOrganization', 'tSalesChannel', 'tOOB', 'tOrderForOrganization'],
      'session',
      [true, true, true, true],
    );
    let dispatchPending = false;

    if (
      organizationInSessionStorage &&
      typeGuards.isOrganizationWithUserGroups(organizationInSessionStorage) &&
      organization?.id !== organizationInSessionStorage.id
    ) {
      dispatch(setOrderOrganization(organizationInSessionStorage));
      dispatchPending = true;
    }
    if (
      salesChannelInSessionStorage &&
      typeGuards.isSalesChannel(salesChannelInSessionStorage) &&
      salesChannel?.uuid !== salesChannelInSessionStorage.uuid
    ) {
      dispatch(setOrderSalesChannel(salesChannelInSessionStorage));
      dispatchPending = true;
    }
    if (
      !orderForOrganizationSessionStorage &&
      userInSessionStorage &&
      typeGuards.isUserWithUserGroup(userInSessionStorage) &&
      user?.id !== userInSessionStorage.id
    ) {
      dispatch(setOrderUser(userInSessionStorage));
      dispatchPending = true;
    }

    setLoading(dispatchPending);
  }, [organization, salesChannel, user]);

  return (
    <OrderFlowLayout>
      <div>
        <Gutter size={'layout-5'} />
        <OrderStepper />
      </div>

      {loading && <Loader />}

      {!loading && organization && salesChannel && (
        <Switch>
          <Route path={`${path}/${ORDER_FLOW_CONSTANTS.selectProduct}`} component={SelectProduct} />
          <Route path={`${path}/${ORDER_FLOW_CONSTANTS.bundle}/:bundleId`} component={Bundle} />
          <Route path={`${path}/${ORDER_FLOW_CONSTANTS.checkoutDetails}`} component={CheckoutDetails} />
          <Route path={`${path}/${ORDER_FLOW_CONSTANTS.deliveryOptions}`} component={DeliveryOptions} />
          <Route path={`${path}/${ORDER_FLOW_CONSTANTS.orderCompleted}`} component={OrderCompleted} />
          <Redirect to={`${path}/${ORDER_FLOW_CONSTANTS.selectProduct}`} />
        </Switch>
      )}

      <Gutter size="xlg" />
    </OrderFlowLayout>
  );
}
